module.exports = __webpack_public_path__ + "media/logos/press-logo-spread-persona-white-deb03927.png";